import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'

import Button from '../../../Button'
import { Checkbox, CHECKBOX_SIZE } from '../../../Checkbox'
import {
  FormikField,
  getFormikCheckboxFieldErrorProps,
  getFormikCheckboxFieldValueProps,
} from '../../../Formik'
import { USER_FORM_FIELD_NAME_SEND_INVITATION } from '../../../User'

import * as styles from './InhabitantFormInvitationActions.module.css'

function InhabitantFormInvitationActions({
  isSubmitting,
  onOpenInvitationModal,
}) {
  const { t } = useTranslation()

  const [field] = useField(USER_FORM_FIELD_NAME_SEND_INVITATION)

  return (
    <div className={styles.checkboxField}>
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        className={styles.checkbox}
        getErrorProps={getFormikCheckboxFieldErrorProps}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('Modal.SendInvitationLabelKey')}
        name={USER_FORM_FIELD_NAME_SEND_INVITATION}
        size={CHECKBOX_SIZE.small}
      />

      <Button.Text
        className={styles.viewButton}
        disabled={isSubmitting || !field.value}
        text={t('Modal.TextViewBtnKey')}
        onClick={onOpenInvitationModal}
      />
    </div>
  )
}

export default InhabitantFormInvitationActions
